import React, { useContext, useEffect } from "react";
import { Drawer, Portal } from "@mantine/core";
import { CLOSE_CART, Context, OPEN_CART } from "../../context";
import { useSelector } from "react-redux";
import "./styles.css";
import DrawerList from "./DrawerList";
import DrawerAlert from "./DrawerAlert";
import DrawerFooter from "./DrawerFooter";
import CountdownContainer from "../Header/CountdownContainer";
import classes from "./Drawer.module.css";
import { useMediaQuery } from "@mantine/hooks";

const DrawerCart = ({ sale, cartOpen }) => {
  const { language } = useSelector((state) => ({
    language: state.language,
  }));
  const { dispatch } = useContext(Context);

  const isMobile = useMediaQuery("(max-width: 768px)");

  useEffect(() => {
    if (sale?.itemQuantity !== 0 && !cartOpen) {
      dispatch({ type: OPEN_CART });
    }
  }, [sale]);

  return (
    <Portal>
      <Drawer
        opened={cartOpen}
        onClose={() => dispatch({ type: CLOSE_CART })}
        padding="24px"
        size={isMobile ? "sm" : 500}
        position="right"
        className={classes.cart}
        aria-label={`${language.CartIsOpen}, ${language.Cart_Quantity} ${sale?.itemQuantity} ${language.Articles}`}
        closeButtonProps={{
          "aria-label": language.Close,
        }}
        aria-describedby="drawer-body"
        withinPortal={false}
        title={language.Cart}
      >
        <div className={classes.itemWrapper}>
          <div aria-live="polite">
            <DrawerAlert />
            <CountdownContainer />
            {sale?.items.length === 0 && <p>{language.EmptyCart}</p>}
            <DrawerList sale={sale} />
          </div>
          <DrawerFooter sale={sale} />
        </div>
      </Drawer>
    </Portal>
  );
};

export default DrawerCart;
